import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

import { Heading3, Heading5, SmallText } from '@common/Typography';

export const AppointmentInfoContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  background-color: ${({ disabled, theme }) =>
    disabled ? 'rgba(152, 152, 152, 0.5)' : theme.colors.WHITE};
  margin-top: 1rem;
`;

export const AppointmentInfo = styled.div`
  display: flex;
  margin: 0 0.25rem;
  flex: 1;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

export const AppointmentInfoMeta = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
  height: 6rem;
  width: 6rem;
  padding: 1rem;
  justify-content: center;
  align-items: center;
`;

export const AppointmentInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 6rem;
  padding: 1rem;
  flex: 1;
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
  border-left: 0;
`;

export const AppointmentInfoDayOfMonth = styled(Heading3)`
  color: ${({ theme }) => theme.colors.BRAND};
  font-weight: 400;
`;

export const AppointmentInfoMonth = styled(Heading5)`
  color: ${({ theme }) => theme.colors.BRAND};
`;

export const MetaText = styled(SmallText)`
  color: ${({ theme }) => theme.colors.GREY_1};
`;

export const MeetingTypeInfoText = styled(MetaText)`
  margin-top: 1rem;
`;

export const AppointmentInfoMeetingTypeIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.BRAND};
  width: 2.5rem !important;
  height: 2.5rem !important;
`;
